"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var samStoreRouter = {
  path: '/samStore',
  component: _layout.default,
  redirect: '/samStore/samSkuList',
  name: 'SamStore',
  meta: {
    title: '山姆管理',
    icon: 'shopping'
  },
  children: [{
    path: 'samSkuList',
    name: 'SamSkuList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jdStore/samSkuList/index.vue'));
      });
    },
    meta: {
      title: '山姆SKU列表',
      icon: ''
    }
  }, {
    path: 'samSrot',
    name: 'SamSrot',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/jdStore/samSrot/index.vue'));
      });
    },
    meta: {
      title: '山姆分类',
      icon: ''
    }
  }]
};
var _default = exports.default = samStoreRouter;